import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './components/app/app.module';

// Basic Logger setup
export const Logger = {
  info: (message: string, extra?: any) => {
    console.log(`INFO: ${message}`, extra || '');
  },
  warn: (message: string, extra?: any) => {
    console.warn(`WARN: ${message}`, extra || '');
  },
  error: (message: string, extra?: any) => {
    console.error(`ERROR: ${message}`, extra || '');
  }
};

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true
  })
  .then(() => Logger.info('Angular app bootstrapped successfully'))
  .catch(err => Logger.error('Angular app failed to bootstrap', err));
